import React, { FC, useContext, useMemo } from 'react';
import { Box } from '@src/atoms/Box';
import { Button } from '@src/atoms/Button';
import { Text } from '@src/atoms/Text';
import { TErrorType, TPageView } from './models';
import { DEFAULT_LINK, DEFAULT_LINK_TEXT, ERROR_CONTENT } from './const';
import { BreakpointsContext } from '@src/providers/Breakpoints';
import { getClass } from '@src/utils/getClass';
import { classnames } from '@src/utils/classnames';
import { IClassNameProps, IStylesProps } from '@src/models/props';

import styled from './ErrorPage.module.scss';
import { Unit } from '@src/core/Unit';
import { Logo } from '@src/atoms/Logo';

interface IProps extends IClassNameProps, IStylesProps {
  /** Режим отображения */
  view?: TPageView;

  /** тип ошибки */
  errorType: TErrorType;

  /** Кастомное описание ошибки (в случае отсутствия заменяется на дефолтное из ERROR_CONTENT) */
  errorDescription?: string;
}

export const ErrorPage: FC<IProps> = ({ view = 'black', errorType, className, style, errorDescription }) => {
  const { isMobile } = useContext(BreakpointsContext);
  const classes = classnames(className, styled.root, getClass(styled, 'view', view), { [styled.rootMobile]: isMobile });
  const {
    header,
    title,
    link = DEFAULT_LINK,
    linkText = DEFAULT_LINK_TEXT,
  } = useMemo(() => ERROR_CONTENT[errorType], [errorType]);
  const description = errorDescription ? errorDescription : ERROR_CONTENT[errorType].description;

  return (
    <section className={classes} style={style}>
      <Unit id={'ErrorPage'} env={{ errorType, view }}>
        <Box>
          {view == 'black' && (
            <Box className={styled.logo}>
              <Logo href={'/'} />
            </Box>
          )}

          <Box column alignItems="center" padding={{ MOBILE: 16, DESKTOP: 32 }} className={styled.content}>
            <Text id={'title'} weight="bold" className={styled.title}>
              {title}
            </Text>
            <Text id={'header'} size="h3">
              {header}
            </Text>
            <Box marginTop={{ DESKTOP: 16, MOBILE: 8 }}>
              <Text id={'description'} align="center">
                {description}
              </Text>
            </Box>

            <Box justifyContent="center" paddingTop={{ DESKTOP: 32, MOBILE: 16 }}>
              <Button
                href={link}
                disableNextJs
                size="lg"
                view={view === 'black' ? 'secondaryDark' : 'secondaryLight'}
                id={'gotoBtn'}
              >
                {linkText}
              </Button>
            </Box>
          </Box>
        </Box>
      </Unit>
    </section>
  );
};
